export const Location = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="locationIcon"
  >
    <path
      d="M10.0004 8.85869C11.4689 8.85869 12.6634 7.66413 12.6634 6.19565C12.6634 4.72717 11.4689 3.53261 10.0004 3.53261C8.53191 3.53261 7.33734 4.72717 7.33734 6.19565C7.33734 7.66413 8.53191 8.85869 10.0004 8.85869Z"
      stroke="#357844"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0003 1.25C12.884 1.25 15.2123 3.58587 15.2123 6.46957C15.2123 8.91957 11.4536 14.9837 10.3199 16.7565C10.2514 16.863 10.1297 16.9315 10.0003 16.9315C9.87097 16.9315 9.74923 16.863 9.68075 16.7565C8.54706 14.9837 4.78836 8.91957 4.78836 6.46957C4.78836 5.08478 5.33619 3.76087 6.31771 2.77935C7.29923 1.79783 8.62314 1.25 10.0079 1.25H10.0003Z"
      stroke="#357844"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.8046 15.8587C16.7339 16.1022 18.7502 16.6272 18.7502 17.2283C18.7502 18.0652 14.8317 18.75 10.0002 18.75C5.16869 18.75 1.25021 18.0652 1.25021 17.2283C1.25021 16.6272 3.25891 16.1098 6.16543 15.8587"
      stroke="#357844"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
